// removed by extract-text-webpack-plugin
module.exports = {"tipsTextBg":"_3m_i-2ZU07OxXWlcptcgJh","change":"_2wc7AvhKIrKmopWq1LxOm_","tipsTextBox":"_1oIp_cKrdsjyA_fyrQmQRs","tipsTextTop":"_3jOUHVDrB9tp054VaKkXMx","tipsText":"_3YqxSeGu6Li9JTXBTBognS","tipsTextEmpty":"_1HzwvtI15vEFIFCRNJrcHx","tipsIcon":"_3DCvyeOHGVP4fbUEch-nph","numberInput-box":"_3pSoxALXboByv7tW7TDvOo","numberInput-minus":"_29kdHLN9yA4dTyXKGVa5QQ","numberInput-plus":"_10cqeq-Y9qxymsZoojOH2s"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/SDKLiveness/ItemLiveInterfaceTips.module.less
// module id = 755
// module chunks = 0